<template>
	<div class="wrap">
		<!-- 面包屑导航区 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item class="test" :to="{ path: '/jianjie' }">集团简介设置</el-breadcrumb-item>
			<el-breadcrumb-item>编辑发展历程</el-breadcrumb-item>
		</el-breadcrumb>

		<el-card>
			<el-form label-width="110px" :model="formData">

				<el-form-item label="年份">
					<el-input v-model="formData.time"></el-input><!-- v-model="formLabelAlign.region" -->
				</el-form-item>
				<el-form-item label="权重">
					<el-input v-model="formData.weights" type="number"></el-input><!-- v-model="formLabelAlign.region" -->
				</el-form-item>
				<el-form-item label="内容">
					<!-- 富文本编辑器 -->
					<quill-editor v-model="formData.quillData" ref="myref"></quill-editor>
				</el-form-item>
			</el-form>

			<el-button type="success" class="submitBtn" @click="submit">立即提交</el-button>
		</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				id: '',
				formData: {
					time: '',
					weights: '',
					quillData: ''

				},
				fileList: [],
				fileList2: [],
				uploadUrl: this.$httpTitle + '/uploadImgQiniugroup?pathName=activityNewInfo'
			}
		},
		created() {
			console.log('获取到的id===' + this.$route.query.id)
			this.id = this.$route.query.id;
			this.get_data();
		},
		methods: {
			async get_data() {
				var res = await this.$http.get('/v1/official/manag/development/process/detail', {
					params: {
						id: this.id
					}
				})
				console.log('发展详情数据=' + JSON.stringify(res))
				if (res.data.code == 0) {
					this.formData.time = res.data.data.developmentTime;
					this.formData.weights = res.data.data.weights;
					this.formData.quillData = res.data.data.content
				}
				var data = {
					"data": {
						"code": 0,
						"message": "success.",
						"data": {
							"id": 6,
							"createTime": 1591928628000,
							"updateTime": 1591928630000,
							"developmentTime": "2019",
							"content": "<p>\r\n    <strong>2019年，创建慕茹姬医用美妆品牌；</strong>\r\n</p>\r\n<p>\r\n    慕茹姬美妆品牌依托九航集团的力量，开展线上线下相结合的销售模式，销售团队管理水平得到了进一步提升，为团队规模扩大打下了坚实的基础。\r\n</p>\r\n<p>\r\n    <br/>\r\n</p>\r\n<p>\r\n    <strong>2019年，九航与云南省农业科学院茶叶研究院种植基地签订合约；</strong>\r\n</p>\r\n<p>\r\n    宜关茶品牌将围绕做强茶叶品质、做大茶叶品牌目标，通过技术培训、技术咨询、技术服务、技术开发等方式，与云南省农业科学院茶叶研究种植基地开展合作，矢志为用户提供原产地生态茶叶。\r\n</p>\r\n<p>\r\n    <br/>\r\n</p>",
							"weights": 6
						}
					},
					"status": 200,
					"statusText": "",
					"headers": {
						"date": "Tue, 30 Jun 2020 07:33:27 GMT",
						"transfer-encoding": "chunked",
						"content-type": "application/json;charset=UTF-8"
					},
					"config": {
						"url": "/v1/official/manag/development/process/detail",
						"method": "get",
						"params": {
							"id": "6"
						},
						"headers": {
							"Accept": "application/json, text/plain, */*",
							"Authorization": "1:76B60475C4EA29CD8A3A050C57EB3FD4A59BD0E0ED4708B4"
						},
						"baseURL": "http://xhm.jiuhuakang.com",
						"transformRequest": [null],
						"transformResponse": [null],
						"timeout": 0,
						"xsrfCookieName": "XSRF-TOKEN",
						"xsrfHeaderName": "X-XSRF-TOKEN",
						"maxContentLength": -1
					},
					"request": {}
				}
			},
			formatTime(timeStamp) {
			 var date = new Date();
			 date.setTime(timeStamp * 1000);
			 var y = date.getFullYear();
			 var m = date.getMonth() + 1;
			 m = m < 10 ? ('0' + m) : m;
			 var d = date.getDate();
			 d = d < 10 ? ('0' + d) : d;
			 var h = date.getHours();
			 h = h < 10 ? ('0' + h) : h;
			 var minute = date.getMinutes();
			 var second = date.getSeconds();
			 minute = minute < 10 ? ('0' + minute) : minute;
			 second = second < 10 ? ('0' + second) : second;
			 return y; //+ ' ' + h + ':' + minute + ':' + second;
			},
			onRemove(file, fileList) { //fileList剩下的会打印出来 response字段
				console.log('onRemove=' + JSON.stringify(fileList))
				var newfileList = []
				this.fileList2.forEach((item1, index1) => {
					fileList.forEach((item2, index2) => {
						if (item1 == item2.response) {
							/* this.fileList2.splice(index1, 1) */
							newfileList.push(item2.response)
						}
					})
				})
				this.fileList2 = newfileList

			},
			onSuccess(res) {
				console.log('onSuccess=' + res)
				this.fileList2.push(res)
			},
			async submit() {
				var obj = {};
				obj['id'] = this.id;
				obj['developmentTime'] = this.formData.time;
				obj['weights'] = +this.formData.weights;
				obj['content'] = this.formData.quillData;
				console.log(JSON.stringify(obj))
				
				var res = await this.$http.post('/v1/official/manag/development/process/update', {
					request: obj
				})
				console.log('修改结果='+JSON.stringify(res))
				if (res.data.code == 0) {
					this.$message.success('修改成功');
					
				} else {
					this.$message.error(res.data.message)
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.submitBtn {
		margin-left: 110px;
		margin-top: 90px;
	}
</style>
